

/**
 * The end-part of a URL.
 */
export class Path {
    private readonly path: string;
    private readonly params?: { [key: string]: string };
    private readonly anchor?: string;

    constructor(path: string, params?: { [key: string]: string }, anchor?: string) {
        this.path = path;
        this.params = params;
        this.anchor = anchor;
    }

    withParam(key: string, value: string): Path {
        return new Path(
            this.path,
            {
                ...(this.params ?? {}),
                [key]: value,
            },
            this.anchor,
        );
    }

    withOptionalParam(key: string, value?: string): Path {
        return (value !== undefined ? this.withParam(key, value) : this);
    }

    getBasePath(): string {
        return this.path;
    }

    toString() {
        let url = this.path;

        // Add query parameters if present
        if (this.params) {
            const searchParams = new URLSearchParams();
            let hasParams = false;
            for (const key in this.params) {
                searchParams.set(key, this.params[key]);
                hasParams = true;
            }
            if (hasParams) {
                url += `?${searchParams.toString()}`;
            }
        }

        // Add anchor after query parameters (standard URL format)
        if (this.anchor) {
            url += `#${this.anchor}`;
        }

        return url;
    }
}
